import React from "react";
import { NavLink } from "react-router-dom";

import { FormFooter } from "../../../common/components/form";
import { Button } from '@blueprint/ui';

import PublicFormContainer from "./PublicFormContainer";

const ResetPasswordInvalidMessage = (): JSX.Element => {
    return (
        <PublicFormContainer>
            <h2 className="text-secondary mb-4">Invalid Link</h2>
            <p className="mb-5">
                This link may be used or expired. Please contact your
                administrator for a new link.
            </p>
            <FormFooter className="d-flex mb-5">
                <NavLink
                    to="/login"
                >
                    <Button
                        type="submit"
                        variant="light.primary">Back To Login</Button>
                </NavLink>
            </FormFooter>
        </PublicFormContainer>
    );
};

export default ResetPasswordInvalidMessage;
